import logoBlack from '../logo-black.png';
import logoWhite from '../logo-white.png';
import { Image, useMantineColorScheme } from '@mantine/core';
import React from 'react';

const Logo: React.FC = () => {
  const { colorScheme } = useMantineColorScheme();
  const logo = colorScheme === 'dark' ? logoWhite : logoBlack;

  return <Image src={logo} />;
};

export default Logo;
